import React from 'react';

import { Form } from '@bd-uikit-web/React/Form';
import FormHelper from '@bd-uikit-web/React/FormHelper';

import bdAuth from '@bd-uikit-web/js-helpers/bdAuth';
import bdReq from '@bd-uikit-web/js-helpers/bdReq';
import rootDispatcher from '@bd-uikit-web/js-helpers/rootDispatcher';

export default class Redeem extends React.Component {
  constructor(props) {
    super();
    this.props = props;
    this.state = {
      sending: false,
      couponInformation: null,
      playlist: null,
      code: '',
    };

    this.onFormSubmit = this.onFormSubmit.bind(this);
    this.fH = new FormHelper((code) => this.setState({ code }));
  }

  componentWillMount() {
    if (!bdAuth.isAuthenticated()) {
      rootDispatcher.dispatch('EDITPROFILE');
      this.props.history.push('/?redirect-url=/redeem');
      return;
    }
    this.getUser();
  }

  onFormSubmit(data) {
    if (this.state.sending) {
      return false;
    }

    bdReq.post(`/users/${this.state.user.id}/coupons`, { code: data.code })
      .then(({ success, body }) => {
        this.setState({ couponInformation: body.information });

        if (body.information && body.information.type === 'playlist') {
          this.getPlaylist();
        }
        if (!success) {
          this.unsetStateSending();
          this.showNotiBanner('error', body.message);
          return;
        }
        this.unsetStateSending();
        this.showNotiBanner('success', body.message);
      });
    return true;
  }

  getPlaylist() {
    bdReq.get(`/users/${this.state.user.id}/playlists/${this.state.couponInformation.playlistId}`)
      .then(({ success, body }) => {
        this.setState({ playlist: body });
        if (!success) {
          this.unsetStateSending();
          this.showNotiBanner('error', body.message);
          return;
        }
        this.unsetStateSending();
        this.showNotiBanner('success', body.message);
      });
    return true;
  }

  getUser() {
    // getUser is synchronous now
    const user = bdAuth.getUser();
    if (user !== null) {
      // Format the date from the api into a useable format.
      user.dateOfBirth = new Date(Date.parse(user.dateOfBirth));

      this.fH.setStorage(user);
      this.setState({ sending: false, selectedCountry: user.country, user });
      return;
    }
    this.showNotiBanner('error', 'The account could not be found');
  }

  // @todo move this to a static global place.
  setStateSending() {
    this.setState({ sending: true });
  }

  showNotiBanner(type, message) {
    rootDispatcher.dispatch('NB:OPEN', { type, msg: message });
  }

  unsetStateSending() {
    this.setState({ sending: false });
  }

  render() {
    return (<div>

      <Form onSubmit={this.onFormSubmit}>
        <section className="row">
          <div className="col-12">
            <h4 className="h--underline h--regular-weight">Redeem your Coupon</h4>
          </div>

          {
            this.state.couponInformation
              ? <div className="col-12">
                <div className="card">
                  <section className="row row--push-btm-xs">
                    <div className="col-12">
                      <h6 className="h--regular-weight">You've just received:</h6>
                    </div>
                    <div className="col-12">
                      {
                        this.state.couponInformation.type === 'playlist' &&
                          this.state.playlist !== null
                          ? (<span> The
                            <strong>{this.state.playlist.name}</strong>Playlist, containing
                            <strong>{this.state.playlist.artworks.length}</strong>
                           artworks at the moment.</span>)
                          : (<span>A <strong>
                            {this.state.couponInformation.subscriptionType}</strong>
                            Subscription for <strong>
                            {this.state.couponInformation.length}</strong> days.</span>)
                      }
                    </div>
                  </section>
                </div>
              </div>
              : (null)
          }

          <div className="col-12">
            <div className="card">
              <section className="row row--push-btm-xs">
                <div className="col-6 col-ngl" data-required="true">
                  {
                    this.fH.getInput('Coupon Code', 'code', 'Coupon Code', {
                      required: true,
                      type: 'text',
                    })
                  }
                </div>
              </section>
              <section className="row">
                <button className="pull-left" disabled={this.state.sending} type="submit">
                  Redeem
                </button>
              </section>
            </div>
          </div>
        </section>
      </Form>
    </div>);
  }
}
